import { HttpRequest } from 'app/libs/http-client';

import { BaseFilterModel, DataGridFilter } from '../create-data-grid-filter';

export const oneOfAsyncFilterModelName = 'one_of_async_filter';

export type OneOfAsyncFilterModel = BaseFilterModel<
  number,
  typeof oneOfAsyncFilterModelName
>;

export type RenderOptionsList = {
  label: string;
  value: number;
}[];

type DataRequest = () => HttpRequest;
type PrepareRequestedData = (data: any) => RenderOptionsList;

export type OneOfAsyncFilterParams = {
  /**
   * The name of the field for filtering in the server-side API
   */
  filterName: string;

  asyncData: {
    request: DataRequest;
    prepareData: PrepareRequestedData;
  };
  closeWhenChanged?: boolean;
};

type CreateOneOfAsyncFilterModelParams = {
  value: number;
  filterName: string;
};

export type OneOfAsyncDataGridFilter = DataGridFilter<
  OneOfAsyncFilterModel,
  OneOfAsyncFilterParams
>;

export const createOneOfAsyncFilterModel = ({
  value,
  filterName,
}: CreateOneOfAsyncFilterModelParams): OneOfAsyncFilterModel => {
  return {
    filterModelName: oneOfAsyncFilterModelName,
    value,
    filterName,
  };
};
